import useNavigate from 'src/hooks/useNavigate';
import { useAppDispatch, useAppSelector } from 'src/hooks/useStore';
import { togglePrimarySidebarMobile } from 'src/store/ui/actions';

/** Navigates, then closes the mobile drawer so it doesn't stay open over the destination. */
export const useSettingsSidebarNavigate = () => {
  const { navigate } = useNavigate();
  const dispatch = useAppDispatch();
  const isMobileDrawerOpen = useAppSelector(
    (state) => state.ui.primarySideBarMobile.isOpen,
  );

  return (path: string) => {
    navigate(path);
    if (isMobileDrawerOpen) {
      dispatch(togglePrimarySidebarMobile({ isOpen: false }));
    }
  };
};
